import _ from 'underscore';

export const learnMoreHelpIds = {
  Hold: 'app50043',
  PendingPaymentMethod: 'app50054',
  PausedZeroBalance: 'app50053',
  PausedNoValidIO: 'app50035',
  PendingNewCustomer: 'app54626',
  Processing: 'app50051',
};

export const alertActionConfig = {
  Hold: {
    relativePath: 'cc/CreditHold/Dashboard',
  },
  PendingPaymentMethod: {
    relativePath: 'cc/PaymentMethods',
  },
  PausedZeroBalance: {
    relativePath: 'cc/Payment/Prepay',
  },
  PausedNoValidIO: {
    relativePath: 'cc/InsertionOrder',
    params: {
      isPendingFilterSet: 'False',
    },
  },
};

const alertReasonIdList = [
  'NotSet',
  'PausedDueToSystemIssue',
  'PausedZeroBalance',
  'PausedNoValidIO',
  'Processing',
  'PendingPaymentMethod',
  'PendingNewCustomer',
  'Inactive',
  'Hold',
  'Deleted',
];

const accountInactiveCauseCodeList = [
  'NotSet',
  'PausedDueToSystemIssue',
  'PausedZeroBalance',
  'PausedNoValidIO',
  'Processing',
  'PendingPaymentMethod',
  'PendingNewCustomer',
  'Inactive',
  'Hold',
  'AccountLifecycleStatusSuspended',
  'AccountLifecycleStatusDraft',
  'AccountLifecycleStatusDeleted',
  'AccountLifecycleStatusUserPause',
  'AccountFinancialStatusProposed',
  'AccountFinancialStatusWriteOff',
  'AccountFinancialStatusTaxOnHold',
  'AccountFinancialStatusUserHold',
  'AccountFinancialStatusPendingCreditCheck',
  'AccountFinancialStatusSoldToOnly',
  'AdvertiserCustomerLifecycleStatusDraft',
  'AdvertiserCustomerLifecycleStatusInactive',
  'AdvertiserCustomerLifecycleStatusDeleted',
  'AdvertiserCustomerFraudStatusFraud',
  'BillToCustomerLifecycleStatusDraft',
  'BillToCustomerLifecycleStatusInactive',
  'BillToCustomerLifecycleStatusDeleted',
  'BillToCustomerFinancialStatusProposalsOnly',
  'BillToCustomerFinancialStatusSoldToOnly',
  'BillToCustomerFraudStatusFraud',
  'AccountLifecycleStatusNotSet',
  'AccountFinancialStatusNotSet',
  'AdvertiserCustomerLifecycleStatusNotSet',
  'AdvertiserCustomerFraudStatusNotSet',
  'BillToCustomerLifecycleStatusNotSet',
  'BillToCustomerFinancialStatusNotSet',
  'BillToCustomerFraudStatusNotSet',
];

export const alertReasonId = _.invert(alertReasonIdList);

export const accountInactiveCauseCode = _.invert(accountInactiveCauseCodeList);

export const i18nPrefixes = {
  alertCategoryPrefix: 'AccountAlertCategory',
  alertDescriptionPrefix: 'AccountAlertDescription',
  alertReasonPrefix: 'AccountAlertReason',
  alertActionPrefix: 'AccountAlertAction',
};

export const popupId = 'accountAlertDetailsContainer';
